import React from "react";
import Styles from "./styles/pr.module.css";

const BibleMemory = (props) => {
    return (<>
        <iframe src="./bible_mem/index.html" width="100%" height="500px" />
    </>)
}
export default BibleMemory;